import { AuthBindings } from '@refinedev/core';
import { mainAuthProvider } from './mainAuthProvider';
import { monitoringAuthProvider } from './monitoringAuthProvider';

/**
 * Composite auth provider that delegates to the appropriate auth provider
 * based on the current route path.
 *
 * Routes starting with /monitoring use monitoringAuthProvider
 * All other routes use mainAuthProvider (with terms agreement support)
 */
export const compositeAuthProvider: AuthBindings = {
  login: async params => {
    const isMonitoringRoute = window.location.pathname.startsWith('/monitoring');
    return isMonitoringRoute
      ? monitoringAuthProvider.login(params)
      : mainAuthProvider.login(params);
  },

  logout: async () => {
    const isMonitoringRoute = window.location.pathname.startsWith('/monitoring');
    return isMonitoringRoute ? monitoringAuthProvider.logout() : mainAuthProvider.logout();
  },

  check: async () => {
    const isMonitoringRoute = window.location.pathname.startsWith('/monitoring');
    return isMonitoringRoute ? monitoringAuthProvider.check() : mainAuthProvider.check();
  },

  getPermissions: async () => {
    const isMonitoringRoute = window.location.pathname.startsWith('/monitoring');
    return isMonitoringRoute
      ? monitoringAuthProvider.getPermissions()
      : mainAuthProvider.getPermissions();
  },

  getIdentity: async () => {
    const isMonitoringRoute = window.location.pathname.startsWith('/monitoring');
    return isMonitoringRoute
      ? monitoringAuthProvider.getIdentity()
      : mainAuthProvider.getIdentity();
  },

  onError: async error => {
    const isMonitoringRoute = window.location.pathname.startsWith('/monitoring');
    return isMonitoringRoute
      ? monitoringAuthProvider.onError(error)
      : mainAuthProvider.onError(error);
  },
};
